import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { SmartGridView } from '../../components/GridView/SmartGridView';
import { PlayContainer } from '../../components/PlayContainer/PlayContainer';
import { GridMediaTeaser } from '../../components/Teaser/MediaTeaser/GridMediaTeaser';
import { getMediaAria } from '../../utils/aria-helper';
import { jsx as _jsx } from "react/jsx-runtime";
export const MediaGrid = ({
  medias,
  canLoadMore = false,
  loadMore,
  analyticsTitle,
  labelOrder
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(Fragment, {
    children: medias.length > 0 && /*#__PURE__*/_jsx(Layout, {
      children: /*#__PURE__*/_jsx(PlayContainer, {
        children: /*#__PURE__*/_jsx(SmartGridView, {
          canLoadMore: canLoadMore,
          loadMore: loadMore,
          analyticsTitle: analyticsTitle,
          children: medias.map((video, index) => /*#__PURE__*/_jsx(GridMediaTeaser, {
            media: video,
            index: index,
            ariaLabel: `${getMediaAria(video, t)}. ${video.type === 'LIVESTREAM' ? t('global.live') : ''}`,
            labelOrder: labelOrder
          }, video.id))
        })
      })
    })
  });
};
const Layout = styled.div.withConfig({
  displayName: "MediaGrid__Layout",
  componentId: "sc-14e9tjp-0"
})(["margin-top:24px;", "{margin-top:40px;}"], Viewports.for('largeUp'));